import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { selectAuthenticateStatus } from 'selectors/selectors';

const ProtectedRoute = ({ children }) => {
    const isAuth = useSelector(selectAuthenticateStatus);

    if (!isAuth) {
        return <Navigate to="/login" />;
    }
    return children;
};

ProtectedRoute.propTypes = {
    children: PropTypes.shape()
};
export default ProtectedRoute;
